import React from "react";
import AnouncementBar from "./AnouncementBar";
import NavBar from "./NavBar";

export default function LayoutHeader() {
  return (
    <header>
      <AnouncementBar />
      <NavBar />
    </header>
  );
}
